module.exports = __webpack_public_path__ + "img/行业应用_城市排水.ecabfcbf.svg";